import React from "react";
import Skeleton from "react-loading-skeleton";
const CardSkeleton = ({ cards }) => {
  return Array(cards)
    .fill(0)
    .map((item) => (
      <div>
        <Skeleton width={50} height={50} />
      </div>
    ));
};

export default CardSkeleton;
